export class ErrorMessage {

    public errorType: string;
    public existError: boolean;
    public errorList: any[] = [];
    public textColor?: string;
    public bgColor?: string;

    constructor(errorMessageObj?: any) {
        if (errorMessageObj) {
            this.errorType = errorMessageObj.errorType;
            this.existError = errorMessageObj.existError;
            this.errorList = errorMessageObj.errorList;
        }
    }
}
